<div class="layout">
  <app-sidebar></app-sidebar>

  <div class="layout-content" [class.collapsed]="sidebarState.collapsed$ | async">
    <app-header></app-header>

    <main class="page-content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>